import { HttpLink } from 'apollo-link-http';
import { ApolloLink } from 'apollo-link';
import config from '../../config';

export function buildLink(fetchHeaders = {}, link) {
  const modifiedFetch = (request, options) => {
    const newHeaders = {
      ...options.headers,
      ...fetchHeaders
    };
    const newOptions = { ...options };
    newOptions.headers = newHeaders;

    return fetch(request, newOptions);
  };

  const httpLink = new HttpLink({
    uri: config('bffUri'),
    credentials: 'same-origin',
    fetch: modifiedFetch
  });

  return ApolloLink.from([link || httpLink].filter(n => n));
}
